import { useState, useEffect, useCallback } from 'react';

// Este es nuestro nuevo hook, que contendrá toda la lógica.
export function useTheme() {
  // Función para obtener el tema inicial. Se ejecuta solo una vez.
  // Esto evita el "flash" de contenido (FOUC) porque se resuelve antes del primer render.
  const getInitialTheme = useCallback(() => {
    // 1. Prioridad: El tema guardado por el usuario en localStorage.
    if (typeof window !== 'undefined') {
      const savedTheme = window.localStorage.getItem('theme');
      if (savedTheme === 'dark' || savedTheme === 'light') {
        return savedTheme;
      }
      // 2. Segunda prioridad: La preferencia del sistema operativo.
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      return systemPrefersDark ? 'dark' : 'light';
    }
    // 3. Fallback si estamos en el servidor (SSR)
    return 'light';
  }, []);

  const [theme, setTheme] = useState(getInitialTheme);

  // Efecto que aplica la clase 'dark' al <html> y guarda en localStorage.
  useEffect(() => {
    const root = window.document.documentElement;

    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }

    // Guarda la elección del usuario solo si es 'dark' o 'light'
    window.localStorage.setItem('theme', theme);
  }, [theme]);
  
  // Este hook devuelve el estado actual y la función para cambiarlo.
  // ¡Igual que useState, pero con superpoderes!
  return { theme, setTheme };
}